import script from "./CreateNewUserComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateNewUserComponent.vue?vue&type=script&setup=true&lang=js"

import "./CreateNewUserComponent.vue?vue&type=style&index=0&id=6cf29eca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6cf29eca"]])

export default __exports__